var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2133 14.4934C12.08 14.4801 11.92 14.4801 11.7733 14.4934C8.59996 14.3867 6.07996 11.7867 6.07996 8.58675C6.07996 5.32008 8.71996 2.66675 12 2.66675C15.2666 2.66675 17.92 5.32008 17.92 8.58675C17.9066 11.7867 15.3866 14.3867 12.2133 14.4934Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.88 5.33325C24.4667 5.33325 26.5467 7.42659 26.5467 9.99992C26.5467 12.5199 24.5467 14.5733 22.0533 14.6666C21.9467 14.6533 21.8267 14.6533 21.7067 14.6666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54671 19.4133C2.32004 21.5733 2.32004 25.0933 5.54671 27.2399C9.21338 29.6933 15.2267 29.6933 18.8934 27.2399C22.12 25.0799 22.12 21.5599 18.8934 19.4133C15.24 16.9733 9.22671 16.9733 5.54671 19.4133Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4534 26.6667C25.4134 26.4667 26.32 26.0801 27.0667 25.5067C29.1467 23.9467 29.1467 21.3734 27.0667 19.8134C26.3334 19.2534 25.44 18.8801 24.4934 18.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.b9fce9e2558214f218daca0377292599.svg";
export { ForwardRef as ReactComponent };